<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>查验中心</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="90px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="订单号" prop="orderNum">
            <el-input size="small" style="width: 200px;" v-model="formInline.orderNum" placeholder="订单号"></el-input>
          </el-form-item>

          <el-form-item label="所属展会" prop="exhibitionId">
            <el-select v-model="formInline.exhibitionId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in exhList"
                :key="item.id"
                :label="item.exhibitionName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属分类" prop="typeId">
            <el-select v-model="formInline.typeId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in typeSelect"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
          </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">

          <el-table-column prop="userId" label="用户ID" align="center">
          </el-table-column>
          <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
          <el-table-column prop="linkman" label="联系人" align="center"></el-table-column>
          <el-table-column prop="linkPhone" label="联系电话" align="center"></el-table-column>
          <el-table-column prop="typeId" label="所属大类" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.typeId==1">服务类</el-tag>
              <el-tag type="danger" v-if="scope.row.typeId==2">工程类</el-tag>
              <el-tag type="info" v-if="scope.row.typeId==3">餐饮类</el-tag>
              <el-tag v-if="scope.row.typeId==4">租赁类</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="orderDetails" label="购买数量" align="center">
            <template slot-scope="scope">
              <b>{{scope.row.orderDetails.length}}</b>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="实际支付" align="center"></el-table-column>
          <el-table-column prop="totalCashPledge" label="总押金" align="center"></el-table-column>
          <el-table-column prop="exhibitionName" label="展会名称" align="center"></el-table-column>
          <el-table-column prop="status" label="退款状态" align="center">
            <template slot-scope="scope">
              <label v-if="scope.row.status == 0">正常</label>
              <label v-if="scope.row.status == 1">待检验</label>
              <label v-if="scope.row.status == 2">待审核</label>
              <label v-if="scope.row.status == 3">退款中</label>
              <label v-if="scope.row.status == 4">已拒绝</label>
              <label v-if="scope.row.status == 5">已完成</label>
            </template>
          </el-table-column>

          <el-table-column align="center"  prop="createTime" label="申请时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>

          <el-table-column  label="操作" align="left" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleInFo(scope.row)"style="width: 100px;margin: 1px;">订单详情</el-button>
              <el-button size="mini" type="warning" @click="handleEdit(scope.row,1)"style="width: 100px;margin: 1px;" v-if="scope.row.status === 1">上传结果</el-button>
              <el-button size="mini" type="warning" @click="handleEdit(scope.row,2)"style="width: 100px;margin: 1px;" v-if="scope.row.status === 2">修改结果</el-button>
            </template>
          </el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click='closeDialog("edit")':close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="押金总额" prop="totalCashPledge">
              <label>{{editForm.totalCashPledge}}</label>
            </el-form-item>

            <el-form-item label="实际可退" prop="refCashPledge">
              <el-input type="number"  v-model="editForm.refCashPledge" ></el-input>
            </el-form-item>

            <el-form-item label="备注说明" prop="remark">
              <el-input type="textarea" size="small"  v-model="editForm.remark" ></el-input>
            </el-form-item>

            <el-form-item label="上传凭证" prop="bannerImage">
              <el-upload
                list-type="picture-card"
                :action="this.host+'/fileUpload/ossBatch'"
                :file-list="bnImages"
                :on-success="handleBannerAvatarSuccess"
                :before-upload="beforeBannerAvatarUpload"
                :on-remove="handleBannerRemove"
                :limit="3">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">图片尺寸800*800。数量不超过3张。</div>
              </el-upload>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title" :loading="loading" :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>



      </el-main>
    </el-container>
  </div>
</template>

<script>



import {qryOrderStatusList,upRefundOrderStatus} from '../../api/convenience'
import {qryExhibitionList} from '../../api/courseApi'
import {timestampToTime,parseTime} from "../../utils/util";
import Pagination from '../../components/Pagination'
import ElInputNumber from "../../../node_modules/element-ui/packages/input-number/src/input-number.vue";
import {addBanner, upBanner} from "../../api/rankingApi";


export default {
  name: "productList",
  data() {
    return {
      title:'添加',
      editFormVisible:false,
      loading: false, //是显示加载
      isDisabled: false,
      bnImages:[],
      bnImageUrlList:[],
      formInline:{
        orderNum:'',
        exhibitionId:'',
        typeId:'',
        page:1,
        pageSize:10
      },
      editForm:{
        id:'',
        totalCashPledge:'',
        image:'',
        refCashPledge:'',
        orderNum:'',
        remark:''
      },
      listData:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      exhList:[],
      typeSelect:[{"name":"服务类","value":"1"},
        {"name":"工程类","value":"2"},
        {"name":"餐饮类","value":"3"},
        {"name":"租赁类","value":"4"}],

      // rules表单验证
      rules: {
        refCashPledge: [
          { required: true, message: '请输入可退金额', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注说明', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryExhibitionList({pageSize:1000}).then(res => {
        this.exhList = res.data.list;
      })

      qryOrderStatusList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false
      })
    },


    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },

    //显示编辑界面
    handleEdit: function(row,type) {
      this.editFormVisible = true
      if (type == 1){
        this.title = '上传结果'
      }else {
        this.title = '修改结果'
      }

      this.editForm.id = row.id
      this.editForm.totalCashPledge = row.totalCashPledge
      this.editForm.refCashPledge = row.refCashPledge
      this.editForm.remark = row.remark
      this.editForm.orderNum = row.orderNum
      let strings = row.image.split(",");
      for(let i=0;i<strings.length;i++){
        this.bnImages.push({url:strings[i]});
      }
    },

    //订单详情页面
    handleInFo(info) {
      if (info){
        this.$router.push({ path: '/convenience/refundDetail' ,query:{refundInfo:info}})
      }
    },


    // 编辑、添加提交方法
    submitForm(editData) {


      if (this.editForm.totalCashPledge < this.editForm.refCashPledge){
        this.$message({
          type: 'error',
          message: '退款金额不能大于总押金'
        })
        return ;
      }

      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          let imgs = [];
          for(let i in this.bnImageUrlList){
            if(this.bnImageUrlList[i]){
              imgs.push(this.bnImageUrlList[i]);
            }
          }
          if(imgs.length>0){
            this.editForm.image = imgs.join(",");
          }
          if(this.editForm.id!=''){
            upRefundOrderStatus(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },


    closeDialog(editData){
      this.$refs['editForm'].resetFields();
      this.bnImages = [];
      this.editFormVisible = false;
    },

    resetFrom(){
      this.formInline.typeId = '';
      this.formInline.exhibitionId = '';
      this.formInline.orderNum = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    beforeBannerAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' ;
      const isLt5M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return isJPG && isLt5M;
    },

    handleBannerRemove(file, fileList) {
      if(this.bnImageUrlList[file.uid]){
        this.bnImageUrlList[file.uid] = null;
      }else{
        let j = 0;
        for(let i in this.bnImageUrlList){
          if(this.bnImageUrlList[i]==file.url){
            this.bnImageUrlList[i] = null;
            this.bnImageUrlList.splice(j,1);
          }
          j++;
        }
      }
    },

    handleBannerAvatarSuccess(res, file) {
      this.editForm.image = res.data;
      this.bnImageUrlList[file.uid] = res.data;
    },


  },
  //分页组件
  components: {
    ElInputNumber,
    Pagination
  }
}



</script>



<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/convenience/productList.vue